"use client"
import React from 'react'
import styles from './favorite.module.scss'
import Icon from '@components/icon'
import Button from '@components/buttons/button'
import useFavotire from './useFavotire'

export default function Favorite({stationId}: {stationId: string}) {
    const { toggle, isFavorite } = useFavotire(stationId)

    return (
        <Button className={`${styles.container} ${isFavorite && styles.active}`} onClick={() => toggle()}>
            <div className={`${styles.icons} animated`}>
                <Icon icon={[isFavorite? 'fas': 'far', 'heart']} />
                <span>{isFavorite ? 'הסרה ממועדפים' : 'הוספה למועדפים'}</span>
            </div>
        </Button>
    )
}
